/**
 * @module websocket.event.handlers.aircraft.aircraft-updated
 */
import { store } from '../../../../state/store'
import { setAircraftItemUpdated } from '../../../../state/websocket.slice'

export default function handleAircraftUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAircraftUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAircraftItemUpdated(data))
  }
} 